/**
 * FilterDropdown — 사용자PC(/u/orders) 엑셀형 테이블의 컬럼 필터 드롭다운 UI.
 *
 * 레거시와의 관계
 * ───────────────
 * 기존 public/js/u-order-list.js 의 filter_set / hide_filterList / show_filterList /
 * doSerch_Start / filter_reset / reset_filter_all / resetSearchn / checkKeyUPFilter /
 * show_filter_pop (+ check_resetBtns, 상태 topFileterClickObj / last_show_filterList_key) 를 캡슐화했다.
 * 컬럼헤더 클릭 → 값 목록 드롭다운 → 체크 선택 → orderTax.filter_list 갱신 → apply_filter.
 *
 * 이 슬라이스는 SearchFilter(검색+apply 코어) 이관의 후속이다.
 *   - apply_filter 는 SearchFilter 로 이미 이동 → 여기서는 window.apply_filter 호출.
 *
 * 외부 진입점 → $j.Pages.Desktop.Orders.initialize() 가 window 로 브리지:
 *   - window.filter_set(str,tar,clickObj) : 컬럼헤더 onclick (blade 20여개)
 *   - window.hide_filterList()            : blade 취소 onclick + list.js 잔류 함수
 *   - window.doSerch_Start(st)            : 결과내검색 onclick
 *   - window.filter_reset()               : 컬럼 필터 제거 onclick
 *   - window.reset_filter_all()           : 전체 필터 제거 onclick
 *   - window.resetSearchn()               : 검색어 제거 onclick
 *   - window.checkKeyUPFilter(tar)        : 필터 입력 onkeyup
 *   - window.show_filter_pop()            : 필터 입력 onkeyup/onclick
 *   (show_filterList / check_resetBtns 은 내부 전용 → 비노출)
 *
 * ⚠ 결합 — 모듈은 strict 이므로 전부 window.* 로 접근:
 *   - 데이터/코어 : window.orderTax, window.apply_filter (SearchFilter), window.number_format
 *   - blade 전역(read/write) : window.PoP_lastKey, window.last_show_filterList_n,
 *       window.last_show_filterList_tar, window.serch_tabTar, window.filter_serch_lastHd,
 *       window.ts, window.ts_id, window.debugA
 *   (topFileterClickObj / last_show_filterList_key 는 클러스터 전용 → 인스턴스 필드)
 *
 * ⚠ 베스티지얼: 상태컬럼(n==9) 드롭다운이 부르는 show_checked() / set_itTo() 는
 *   저장소에 정의가 없다(레거시부터 깨진 경로). 원본 그대로 bare 호출을 보존한다.
 */
import Util from '../../../Common/Util';
export default class FilterDropdown {
    constructor() {
        this._topFilterClickObj = null;    // (구)topFileterClickObj : 클릭된 컬럼헤더 엘리먼트
        this._lastShowFilterListKey = undefined; // (구)last_show_filterList_key : 마지막 필터 컬럼번호
    }

    /**
     * 컬럼헤더를 눌러서 필터링 설정하기 (구 filter_set)
     * @param str 컬럼명 @param tar TD id @param clickObj 컬럼헤더 엘리먼트
     */
    filterSet = (str, tar, clickObj) => {
        this.hideList();
        this._topFilterClickObj = clickObj;
        let idx = window.orderTax.show_columns2[str];
        if (idx) {
            this.showList(idx, tar, '', str);
        }
    }

    /** 필터링 팝업 숨기기 (구 hide_filterList) */
    hideList = () => {
        document.getElementById("filter_serkey").value = "";
        document.getElementById("show_serchFilter").style.display = "none";
        document.getElementById("show_paymtStatus").style.display = "none";
    }

    /**
     * 필터링 목록을 표시한다 (구 show_filterList, 내부 전용)
     * @param n 컬럼번호 @param tar TD id @param key 필터 검색어 @param stab 컬럼명
     */
    showList = (n, tar, key, stab) => {
        this._lastShowFilterListKey = n;
        var obj = document.getElementById("show_serchFilter");
        var chall_not = document.getElementById("chall_not");
        chall_not.checked = true;
        window.PoP_lastKey = stab;
        window.last_show_filterList_n = n;
        window.last_show_filterList_tar = tar;
        var tr_id = ["", "caruniqnum", "carPlateval", "", "fieldval", "contractname", "fieldnumber", "serchwho_soo_baljoo", "serchwho_soo_baljoo", "workstatus"];
        var fixtable = document.getElementById("fixtable");// 오더목록이 표시되는 전체 table
        var inputs = fixtable.getElementsByTagName("td"); // 모든 td를 뒤진다.
        var cccc = tar + "_top";
        var ttar = document.getElementById(tar);
        var offsets = ttar.getBoundingClientRect();
        if (this._topFilterClickObj) {
            var tx = this._topFilterClickObj.parentNode;
            offsets = tx.getBoundingClientRect();
        }
        for (var i = 0; i < inputs.length; i++) {
            if (inputs[i].id == cccc) {
                offsets = inputs[i].getBoundingClientRect();
            }
        }
        window.serch_tabTar = tr_id[n];
        var topTablein = document.getElementById("topTablein");
        var ch = window.ts_id.indexOf(tar);
        var ea_list = [];
        var nx;
        if (ch >= 0) {
            nx = window.ts[ch];
        }
        ea_list = window.orderTax.filter_list[stab];

        window.filter_serch_lastHd = nx;
        if (typeof (ea_list) == undefined) ea_list = [];
        if (typeof (ea_list) != "object") ea_list = [];
        obj.style.display = "block";
        obj.style.left = offsets.left + "px";
        obj.style.top = parseInt(offsets.top + offsets.height) + "px";
        inputs = topTablein.getElementsByTagName("TD");
        var ret = "<table width=100% border=1>";
        var olds = [];
        var ks = String.fromCharCode(34);
        var ttn = 1;

        if (n == 9) {
            // ⚠ show_checked / set_itTo 미정의(베스티지얼) — 원본 동작 그대로.
            ret += "<tr><td tdcd=91 style='text-align:center;padding:0px;width:25px'><input type='checkbox' id='eachbox_1' " + show_checked('배차완료', ea_list) + " style='width:20px;height:20px' value='배차완료'></td><td tdcd=92 style='font-weight:bold;cursor: pointer; cursor: hand;' data_target='6' onclick='set_itTo(6)'><label for='eachbox_1'>배차완료</label></td></tr>";
            ret += "<tr><td tdcd=93 style='text-align:center;padding:0px;width:25px'><input type='checkbox' id='eachbox_2' " + show_checked('작업중', ea_list) + "  style='width:20px;height:20px' value='작업중'><td tdcd=94 style='font-weight:bold;cursor: pointer; cursor: hand;' data_target='7' onclick='set_itTo(7)'><label for='eachbox_2'>작업중</label></td></tr>";
            ret += "<tr><td tdcd=95 style='text-align:center;padding:0px;width:25px'><input type='checkbox' id='eachbox_3' " + show_checked('작업완료', ea_list) + "  style='width:20px;height:20px' value='작업완료'><td tdcd=96 style='font-weight:bold;cursor: pointer; cursor: hand;' data_target='8' onclick='set_itTo(8)'><label for='eachbox_3'>작업완료</label></td></tr>";
            ret += "<tr><td tdcd=97 style='text-align:center;padding:0px;width:25px'><input type='checkbox' id='eachbox_4' " + show_checked('수금완료', ea_list) + "  style='width:20px;height:20px' value='수금완료'><td tdcd=98 style='font-weight:bold;cursor: pointer; cursor: hand;' data_target='9' onclick='set_itTo(9)'><label for='eachbox_4'>수금완료</label></td></tr>";
            ret += "<tr><td tdcd=99 style='text-align:center;padding:0px;width:25px'><input type='checkbox' id='eachbox_5' " + show_checked('작업취소', ea_list) + "  style='width:20px;height:20px' value='작업취소'><td tdcd=100 style='font-weight:bold;cursor: pointer; cursor: hand;' data_target='9' onclick='set_itTo(99)'><label for='eachbox_4'>작업취소</label></td></tr>";
        } else {
            // 필터링된것들만 체크 처리하기
            for (var i = 0; i < inputs.length; i++) {
                if (inputs[i].id == tar) {
                    var ea = inputs[i].getAttribute("data_val");
                    var ea_s = " " + ea;
                    var ccdis = inputs[i].parentNode.style.display;
                    if (olds.indexOf(ea) < 0) { //ea != "-1" &&
                        var eeid = "eachbox_" + ttn;
                        var mych = "";
                        if (ea_list.indexOf(ea) >= 0) mych = " checked";
                        if (ea_list.length == 0) mych = " checked";
                        var ex_ex = "";
                        if (ea == "-1") ex_ex = "(X)";
                        var tLine = "<td tdcd=101 style='text-align:center;padding:0px;width:25px'><input type='checkbox' id='" + eeid + "' " + mych + " style='width:20px;height:20px' value='" + Util.escapeHtml(ea) + "' ts=1></td>";
                        if (key == "") {
                            olds.push(ea);
                            ret += "<tr>" + tLine + "<td tdcd=102 style='font-weight:normal;cursor: pointer;'><label for='" + eeid + "'>" + Util.escapeHtml(ea) + ex_ex + "</label></td></tr>";
                            ttn++;
                        } else {
                            if (ea_s.indexOf(key) >= 0) {
                                olds.push(ea);
                                ret += "<tr>" + tLine + "<td tdcd=103 style='font-weight:normal;cursor: pointer;'><label for='" + eeid + "'>" + Util.escapeHtml(ea) + ex_ex + "</td></tr>";
                                ttn++
                            }
                        }
                    }
                }
            }
        }
        obj = document.getElementById("insidefilter");
        ret += "</table>";
        obj.innerHTML = ret;
        document.getElementById("filter_serkey").focus();
        $('#filter_serkey').css("ime-mode", "active");
        document.getElementById("filter_serkey").setAttribute("mode", "active");
    }

    /**
     * 결과 내 검색 (필터 적용) (구 doSerch_Start)
     */
    doSearchStart = (st) => {
        var obj = document.getElementById("insidefilter");
        var inputs = obj.getElementsByTagName("input");
        if (st != "reset") {
            var ret = "";
            if (window.PoP_lastKey.length < 1) { alert("마지막 호출 키값오류"); return; }
            var retArr = [];
            for (var i = 0; i < inputs.length; i++) {
                if (inputs[i].id.indexOf("chbox_") > 0) {
                    if (inputs[i].checked == true) {
                        ret += inputs[i].value + "'";
                        retArr.push(inputs[i].value);
                    }
                }
            }
            window.orderTax.update_column_filter(window.PoP_lastKey, retArr);
        }
        // 모든 컬럼들을 돌면서 체크박스를 업데이트한다.
        window.orderTax.show_columns1.forEach((v, i) => {
            if (i == 0) return;
            let arr = window.orderTax.filter_list[v];
            if (arr && arr.length >= 1) {
                $('#tdx' + i + "_cbox").prop('checked', true);
            } else {
                $('#tdx' + i + "_cbox").prop('checked', false);
            }
        });
        window.apply_filter(false);
        this.hideList();
    }

    /** 선택된 컬럼의 필터를 제거하기 (구 filter_reset) */
    filterReset = () => {
        if (window.filter_serch_lastHd == "") return;
        window.orderTax.reset_column_filter(window.filter_serch_lastHd);
    }

    /** 모든 컬럼의 필터를 제거하기 (구 reset_filter_all) */
    resetFilterAll = () => {
        window.orderTax.init_filter();
        window.orderTax.show_columns1.forEach((v, i) => {
            if (i == 0) return;
            $('#tdx' + i + "_cbox").prop('checked', false);
        });
        window.apply_filter(false);
    }

    /** 검색어 제거 (구 resetSearchn) */
    resetSearch = () => {
        var obja = document.getElementById("searchTot");
        var objb = document.getElementById("serchwho_soo_baljoo");
        obja.value = "";
        objb.value = "";
        this._checkResetBtns();
        window.apply_filter(true);
    }

    /** 검색어 유무에 따라 리셋버튼 표시 (구 check_resetBtns, 내부 전용) */
    _checkResetBtns = () => {
        var obja = document.getElementById("searchTot");
        var objb = document.getElementById("searchresetbtn");
        if (obja.value.length > 1) {
            objb.type = "button";
            obja.style.width = "100px";
        } else {
            objb.type = "hidden";
            obja.style.width = "120px";
        }
    }

    /** 필터 입력 onkeyup (구 checkKeyUPFilter) */
    checkKeyUpFilter = (tar) => {
        if (this._lastShowFilterListKey == undefined) this._lastShowFilterListKey = -1;
        if (this._lastShowFilterListKey < 1) return;
        if (this._lastShowFilterListKey == 14 || this._lastShowFilterListKey == 15) {
            this.showFilterPop();
        }
    }

    /** 필터링 popup 을 띄운다 (구 show_filter_pop) */
    showFilterPop = () => {
        var last_show_filterList_key = document.getElementById("filter_serkey").value; // 필터 검색어(지역 변수, 레거시 셰도잉 보존)
        if (window.PoP_lastKey == "장비대금") {
            var nn = parseInt(last_show_filterList_key);
            if (window.debugA == true) console.log(nn);
            if (isNaN(nn)) {
                alert("숫자만 입력해 주세요");
                return;
            }
            var tt = Util.formatNumber(last_show_filterList_key);
            document.getElementById("filter_serkey").value = tt;
            last_show_filterList_key = tt;
        }
        this.showList(window.last_show_filterList_n, window.last_show_filterList_tar, last_show_filterList_key.trim(), window.PoP_lastKey);
    }
}
